import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type {
  ChatBlock,
  ThoughtStep
} from '@portal/app/shared/components/ai-assistant-panel/types/chat-block.types';
import { PortalBlockErrorComponent } from '@portal/app/shared/components/ai-assistant-panel/thread/block-error.component';
import { PortalBlockResponseComponent } from '@portal/app/shared/components/ai-assistant-panel/thread/block-response.component';
import { PortalBlockThoughtComponent } from '@portal/app/shared/components/ai-assistant-panel/thread/block-thought.component';
import { PortalBlockUserComponent } from '@portal/app/shared/components/ai-assistant-panel/thread/block-user.component';

/**
 * Switches over `displayBlocks()` and renders one focused block component per
 * variant. Live in-flight turn appends a `block-thought live=true` (collapsed
 * "Thinking") and an optional streaming-draft response below it.
 */
@Component({
  selector: 'portal-chat-thread',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PortalBlockUserComponent,
    PortalBlockErrorComponent,
    PortalBlockThoughtComponent,
    PortalBlockResponseComponent
  ],
  templateUrl: './chat-thread.component.html',
  host: { class: 'contents' }
})
export class PortalChatThreadComponent {
  readonly blocks = input.required<readonly ChatBlock[]>();
  readonly responding = input(false);
  readonly liveSteps = input<readonly ThoughtStep[]>([]);
  readonly streamingDraft = input('');
}
